import { create } from "zustand";
import { getAllWorkers } from "../services/Workers";

const useWorkerStore = create((set, get) => ({
  apiLoading: false,
  allWorkers: [],
  pageLimit: 10,
  currentPage: 0,
  totalRecords: 0,
  dataLoaded: false, // Flag to track if data has been loaded
  isInitialized: false, // Flag to track if store has been initialized
  
  // Auto-load data when store is first accessed
  initializeData: async () => {
    const { dataLoaded, apiLoading, isInitialized } = get();
    
    // Only load if not already loaded and not currently loading and not initialized
    if (!dataLoaded && !apiLoading && !isInitialized) {
      set({ isInitialized: true, apiLoading: true });
      
      try {
        const response = await getAllWorkers();
        const workersRes = response?.data;
        
        if (workersRes?.status === "success") {
          set({ 
            allWorkers: workersRes.data.workers, 
            totalRecords: workersRes.data.workers?.length || 0,
            apiLoading: false, 
            dataLoaded: true 
          });
          console.log("Workers data loaded automatically:", workersRes.data.workers);
        } else {
          set({ apiLoading: false });
          console.error("Failed to load workers:", workersRes?.message);
        }
      } catch (error) {
        set({ apiLoading: false });
        console.error("Error loading workers:", error);
      }
    }
  },
  
  setAllWorkers: (data) =>
    set({ allWorkers: data, totalRecords: data?.length || 0, apiLoading: false, dataLoaded: true }),
  setLoading: (value) => set({ apiLoading: value }),
  setPageLimit: (value) => set({ pageLimit: value }),
  setCurrentPage: (value) => set({ currentPage: value }),
  setTotalRecords: (value) => set({ totalRecords: value }),
  setDataLoaded: (value) => set({ dataLoaded: value }),
  resetWorkerData: () => set({ allWorkers: [], totalRecords: 0, currentPage: 0, dataLoaded: false, apiLoading: false, isInitialized: false }),
  refreshWorkerData: async () => {
    // Force a refetch. This store uses `initializeData()` guard that depends on `apiLoading`,
    // and some callers keep `apiLoading` true while awaiting refresh.
    set({ dataLoaded: false, isInitialized: false, apiLoading: true });
    try {
      const response = await getAllWorkers();
      const workersRes = response?.data;

      if (workersRes?.status === "success") {
        set({
          allWorkers: workersRes.data.workers,
          totalRecords: workersRes.data.workers?.length || 0,
          apiLoading: false,
          dataLoaded: true,
        });
      } else {
        set({ apiLoading: false });
        console.error("Failed to refresh workers:", workersRes?.message);
      }
    } catch (error) {
      set({ apiLoading: false });
      console.error("Error refreshing workers:", error);
    }
  },
}));

export default useWorkerStore;
